import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Card as ChakraCard } from '@chakra-ui/card';
import { Card } from 'types';
import { Option, OptionControl } from '../Option';
import styles from './../ContentStyles.module.css';
import optionStyles from './../Option/Option.module.css';
import { Flex } from '@chakra-ui/react';
import classNames from 'classnames';
export interface QuizContentProps {
  content: Card;
  isBuilder?: boolean;
  onOptionSelect?: (questionId: number, optionId: number) => Promise<void>;
}
export const QuizContent = ({
  content,
  isBuilder = false,
  onOptionSelect
}: QuizContentProps) => {
  const question = content.question;
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const checkOverflow = () => {
    const contentElement = contentRef.current;
    if (contentElement) {
      setIsOverflowing(contentElement.scrollHeight > contentElement.clientHeight && contentElement.scrollTop < contentElement.scrollHeight - contentElement.clientHeight);
    }
  };
  useEffect(() => {
    const contentElement = contentRef.current;
    if (contentElement) {
      checkOverflow();
      contentElement.addEventListener('scroll', checkOverflow);
    }
    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', checkOverflow);
      }
    };
  }, []);
  if (isBuilder) {
    return <>
        <div className={`${styles.cardContent} ${styles.questionCard}`} ref={contentRef}>
          <h1 className={styles.questionTitle}>{content.title}</h1>
          {question?.postAnswerText && <ChakraCard width="100%" marginBottom={4} borderRadius="10px">
              <span className={styles.questionDesc}>
                {question.postAnswerText}
              </span>
            </ChakraCard>}
          {question && question.options.map(option => <ChakraCard key={option.index} w="100%" h="auto" my={2} border="4px solid white" borderRadius="10px" className={classNames(optionStyles.optionCard, optionStyles.answered, optionStyles.userSelected)} bgColor={option.isCorrect ? 'venasaur.500' : 'kirby.500'} color="white">
                <Flex w="100%" h="100%" padding={2} gap={2} justifyContent="flex-start" alignItems="center">
                  <OptionControl isCorrect={option.isCorrect} answered />
                  <span className={optionStyles.optionText}>
                    {option.content}
                  </span>
                </Flex>
              </ChakraCard>)}
        </div>
        {isOverflowing && <div className={styles.overflowFader} />}
      </>;
  }
  return <>
      <div className={`${styles.cardContent} ${styles.questionCard}`} ref={contentRef}>
        <h1 className={styles.questionTitle}>{content.title}</h1>
        {question?.postAnswerText && <ChakraCard width="100%" marginBottom={4} borderRadius="10px">
            <span className={styles.questionDesc}>
              {question.postAnswerText}
            </span>
          </ChakraCard>}
        {question && question.options.map(option => <Option key={option.id} answered={question.answered} option={option} onSelect={(event: SyntheticEvent) => {
        !question.answered && onOptionSelect && onOptionSelect(question.id, option.id);
        event.stopPropagation();
        event.preventDefault();
      }} userSelected={option.userSelected} isCorrect={option.isCorrect} isDisabled={question.answered} />)}
      </div>
      {isOverflowing && <div className={styles.overflowFader} />}
    </>;
};